import React, { useMemo, useState } from "react";
import { defineMessages, useIntl } from "react-intl";
import { AIType } from "@evidenceb/ai-handler";
import { Student, TestResult } from "../../../../../../interfaces/Dashboard";
import VisuallyHidden from "../../../../../../components/VisuallyHidden/VisuallyHidden";
import ProgressionBar from "../ProgressionBar/ProgressionBar";
import "./InitialTestCell.scss";
import StudentProgressionModal from "../StudentProgressionModal/StudentProgressionModal";
interface Props {
    student: Student;
}

const InitialTestCell = ({ student }: Props) => {
    const intl = useIntl();
    const testResult = useMemo<undefined | TestResult>(
        () =>
            student.testsResults?.find(
                (test) =>
                    test.type === AIType.BanditManchot ||
                    test.type === AIType.AdaptiveTest
            ),
        [student]
    );
    const [openModal, setOpenModal] = useState<boolean>(false);

    return (
        <div className="initial-test-cell">
            <button onClick={() => setOpenModal(true)}>
                <ProgressionBar
                    className="initial-test-cell__progress-bar"
                    aria-hidden={true}
                    status={testResult?.status ?? "none"}
                />
                <VisuallyHidden as="span">
                    {intl.formatMessage(messages.openTestResult)}
                </VisuallyHidden>
            </button>

            {openModal && testResult && (
                <StudentProgressionModal
                    studentName={`${student.firstname} ${student.lastname}`}
                    studentId={student.id}
                    objectives={student.objectives}
                    isOpen={openModal}
                    testResult={testResult}
                    onDismiss={() => setOpenModal(false)}
                />
            )}
        </div>
    );
};

const messages = defineMessages({
    openTestResult: {
        id: "dashboard-openTestResultDetail",
        defaultMessage: "Open the test's detailed results",
    },
});

export default InitialTestCell;
